/* eslint-disable no-param-reassign */
import Vapi from 'vuex-rest-api';

const schemas = new Vapi({
  state: {
    schemas: {
      nav: {},
      filters: {},
    },
  },
})
  .get({
    action: 'getSchema',
    path: ({
      schema,
    }) => `/api/fetcher/schemas/${schema}`,
    onSuccess: (state, payload, axios, { params }) => {
      state.schemas[params.schema] = payload.data;
    },
  })
  .getStore();

export default schemas;
